<template>
  <div class="workOrder">
    <div class="workOrder_top">
      <div class="mycheckbox">
            <el-checkbox v-model="isMine" @change="mineChange()" >我的</el-checkbox>
          </div>
      <div class="workOrder_top_content">
        <van-list v-model="loading" :finished="finished" offset="20" :immediate-check="false" @load="onLoad"
          finished-text="没有更多了 ~" v-if="demandList.length > 0">
          <div class="workOrder_top_content_box" v-for="(item, index) in demandList" :key="index"
            @click="goDetails(item)">
            <div :class="item.class">
              <div>
                <i class="el-icon-date workOrder_top_content_box_top_i"></i>
                <span class="workOrder_top_content_box_top_span1">{{ item.createTime }}</span>
              </div>
              <span class="workOrder_top_content_box_top_span">
                <span v-if="item.status == 1">待开始</span>
                <span v-if="item.status == 2" >进行中</span>
                <span v-if="item.status == 3">已完成</span>
                <span v-if="item.status == 4" >延期</span>
                <span v-if="item.status == 5">测试驳回</span>
              </span>
            </div>
            <div class="workOrder_top_content_box_content">
              <div class="workOrder_top_content_box_content_title"><span>{{ item.taskName }}</span></div>
              <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="成员："
                :value="item.userName" />
              <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value"
                title="任务类型：">
                <template #default>
                  <span v-if="item.taskType == 1">开发</span>
                  <span v-if="item.taskType == 2">设计</span>
                  <span v-if="item.taskType == 3">测试</span>
                </template>
              </van-cell>
              <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value"
                title="计划开始时间：" :value="item.planStartTime" />
              <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value"
                title="计划结束时间：" :value="item.planEndTime" />
              <van-cell  :border="false" title-class="workOrder_top_content_box_content_cell_title" title="紧急程度："
                value-class="cell_value">
                <template #default>
                  <div class="time colorBoxBig">
                    <span class="colorBox" v-if="item.level == 1" style="background: #F56C6C;"></span>
                    <span class="colorBox" v-if="item.level == 2" style="background: #E6A23C;"></span>
                    <span class="colorBox" v-if="item.level == 3" style="background: #409EFF;"></span>
                  </div>
                </template>
              </van-cell>
            <div class="btnBox" v-if="status == 1 && notAuthorized == 1">
              <van-button type="default" round size="small" v-if="item.status == 1"
                @click.stop="upStatusFun(item, 1, '开始')">开始</van-button>
              <van-button type="info" round size="small" v-if="item.status == 2 || item.status == 4 || item.status == 5"
                @click.stop="upStatusFun(item, 2, '结束')">结束</van-button>
              <van-button type="info" round size="small" v-if="item.status == 2 || item.status == 4 || item.status == 5"
                @click.stop="upStatusFun(item, 3, '延期')">延期</van-button>
              <van-button type="info" round size="small" v-if="item.status == 3 && status != 2"
                @click.stop="upStatusFun(item, 4, '驳回')">驳回</van-button>
            </div>
          </div>
          </div>
        </van-list>
        <van-empty description="暂无数据" v-if="demandList.length  == 0"/>
      </div>
    </div>
    <!-- 添加或修改工单基本信息对话框 -->
    <workTaskPop ref="workTaskPop" @ok="getDemand()"/>
    <div class="backTop" @click="goAddPage('null')">
      <img class="top_iamge" src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png" alt="" />
    </div>
  </div>
</template>

<script>
import { listTask, updateTask, updateStatus, getTask } from '@/api/workOrder';
import { Dialog } from 'vant';
import Cookies from 'js-cookie'
import workTaskPop from '@/views/signIn/workTaskPop'
export default {
  name: "workTask",
  props:['status','orderId'],
  components:{workTaskPop},
  data() {
    return {
      active: 0,
      loading: false,
      finished: false, //数据完全加载结束为 true
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderId: null,
        userId: Cookies.get('userId')
      },
      demandList: [],
      orderList: [],
      form: {},
      remoteLoading: false,
      userList: [],
      notAuthorized:0,
      isMine:true
    };
  },
  mounted() {
    console.log(this.status)
    // console.log(this.$route.params)companyId,userId
    this.getDemand()
    this.notAuthorized = Cookies.get('notAuthorized')
  },
  methods: {
    // 下拉刷新
    onLoad() {
      this.loading = true;
      this.queryParams.pageNum = this.queryParams.pageNum + 1;
      this.getDemand();
    },
    mineChange(e){
      console.log(e,this.isMine)
      this.getDemand()
    },
    getDemand() {
      this.loading = true;
      if (this.queryParams.pageNum == 1) {
        this.demandList = []
      }
      this.queryParams.orderId = this.orderId
      if(this.isMine ){
        this.queryParams.userId = Cookies.get('userId')
      }else{
        this.queryParams.userId = null
      }
      listTask(this.queryParams).then(response => {
        let rows = response.rows;
        rows.forEach(e => {
          let className = ''
          if (e.status == 1) {
            className = 'workOrder_top_content_box_top5'
          } else if (e.status == 2) {
            className = 'workOrder_top_content_box_top3'
          } else if (e.status == 3) {
            className = 'workOrder_top_content_box_top'
          } else if (e.status == 4) {
            className = 'workOrder_top_content_box_top4'
          } else if (e.status == 5) {
            className = 'workOrder_top_content_box_top2'
          }
          e.class = className
        });
        this.demandList = this.demandList.concat(rows);
        console.log(this.demandList);
        this.loading = false;
        const hasNextPage = (response.total / this.queryParams.pageSize) > this.queryParams.pageNum
        if (!hasNextPage) {
          // 加载结束 => 没有下一页
          console.log("结束");
          this.finished = true;
        } else {
          this.finished = false;
        }
        console.log(this.demandList, "demandList");
      });
    },
    //跳转到公共页面
    gotoUrl(path) {
      console.log(11111111111111111);
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=' + path,
        })
      } else {
        this.$router.push(path)
      }
    },
    goDetails(item) {
      var path = "/workTaskDetails/" + item.id
      this.gotoUrl(path)
      // workOrderDetails
    },
    getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1
      const day = String(now.getDate()).padStart(2, '0');

      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const second = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    // 修改状态
    upStatusFun(row, type, title) {
      this.reset();
      this.statusTitle = title
      const that = this
      getTask(row.id).then(response => {
        this.form = response.data;
        if (type == 1) {
          this.statusType = 2
          this.form.realStartTime = this.getCurrentDateTime()
          Dialog.confirm({
            title: '标题',
            message: '是否确认开始',
          }).then(() => {
            that.submitStatus();
            }).catch(() => {
            });
        } else if (type == 2) {
          this.statusType = 3
          this.form.realEndTime = this.getCurrentDateTime()
          Dialog.confirm({
            title: '标题',
            message: '是否确认结束',
          }).then(() => {
            that.submitStatus();
            }).catch(() => {
            });
        } else if (type == 3) {
          this.$refs.workTaskPop.showForm(4,  this.form,'延期')
        } else if (type == 4) {
          this.$refs.workTaskPop.showForm(5,  this.form,'驳回')
        }
      });

    },
    submitStatus() {
      const data = {}
      data.id = this.form.id
      data.status = this.statusType
      data.userId = Cookies.get("userId")
      data.userName = Cookies.get("NickName")
      data.rejectMessage = this.form.rejectMessage
      data.extensionMessage = this.form.extensionMessage
      data.realStartTime = this.form.realStartTime
      data.realEndTime = this.form.realEndTime
      updateStatus(data).then(response => {
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.statusOpen = false;
        this.getDemand();
      });
    },
    // 取消按钮
    cancel() {
      this.statusOpen = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        orderId: null,
        taskType: null,
        level: null,
        userId: null,
        userName: null,
        planStartTime: null,
        planEndTime: null,
        realStartTime: null,
        realEndTime: null,
        status: null,
        extensionMessage: null,
        rejectMessage: null,
        createTime: null
      };
      this.resetForm("form");
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          updateTask(this.form).then(response => {
            this.$message({
              message: '评审成功',
              type: 'success'
            });
            this.queryParams.pageNum = 1
            this.open = false;
            this.getOrderFun();
          });
        }
      });
    },
  },
};
</script>
<style scoped>
workOrder_top {
  background: linear-gradient(90deg, #66CCFF, #3BA1F7);
  padding-top: 90px;
  position: relative;
}

.workOrder_top_content {
  background-color: #F7F8FC;
  border-radius: 20px 20px 0 0;
  width: 100%;
}

.workOrder_top_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.workOrder_top_box_tab {
  width: 90%;
  /* padding-bottom: 10px; */
  border-bottom: 1px solid #E8E8E8;
  padding-top: 6px;
}

.workOrder_top_content_box {
  margin: 0 auto;
  margin-top: 20px;
  background-color: #fff;
  width: calc(100% - 40px);
  padding-bottom: 10px;
  border-radius: 8px;
}

.workOrder_top_content_box_top_i {
  margin-right: 5px;
  font-weight: 700;
}

.workOrder_top_content_box_top_span1 {
  font-weight: 700;
}

.workOrder_top_content_box_content {
  margin-top: 10px;
  padding: 0 15px;
}

.workOrder_top_content_box_content_title {
  font-size: 18px;
  font-weight: 700;
}

.workOrder_top_content_box_content_cell_title {}

/* 发布小按钮 */
.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.btnBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin-bottom: 10px; */
  /* margin-top: 15px; */
  padding:15px 0  10px;
}

.workOrder_top_content_box_content_cell_title {
  color: #666666;
}

.cell_value {
  color: #333;
  font-weight: 700;
}

.cell_value2 {
  color: #3B87F7;
  font-weight: 500;
}

.cell_value3 {
  color: #FF8165;
  font-weight: 500;
}

.colorBoxBig {
  align-items: center;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #999999;
  display: flex;
  align-items: flex-start;
}

.colorBox {
  display: inline-block;
  width: 25px;
  height: 13px;
  border-radius: 3px;
}

.colorBoxBig {
  align-items: center;
}

.cell_value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
<style>
.workOrder .el-dialog--center .el-dialog__body {
  padding-top: 0 !important;
}

.workOrder .van-cell {
  padding: 10px 0 0;
}

.btnBox .van-button {
  margin-left: 10px;
  min-width: 70px;
}
.workOrder .van-tabs__nav{
  background-color: #F7F8FC;
}
</style>